<template>
  <div class="credit-card-inputs" :class="{ complete }">
    <CardNumber
      ref="cardNumber"
      class="stripe-element card-number"
      :stripe="stripe"
      :options="options"
      @change="number = $event.complete"
    />
    <CardExpiry
      ref="cardExpiry"
      class="stripe-element card-expiry"
      :stripe="stripe"
      :options="options"
      @change="expiry = $event.complete"
    />
    <CardCvc
      ref="cardCvc"
      class="stripe-element card-cvc"
      :stripe="stripe"
      :options="options"
      @change="cvc = $event.complete"
    />
  </div>
</template>

<script>
import { CardNumber, CardExpiry, CardCvc } from "vue-stripe-elements-plus";

export default {
  components: { CardNumber, CardExpiry, CardCvc },
  props: ["stripe", "options"],
  data() {
    return {
      complete: false,
      number: false,
      expiry: false,
      cvc: false
    };
  },
  watch: {
    number() {
      this.update();
    },
    expiry() {
      this.update();
    },
    cvc() {
      this.update();
    }
  },
  methods: {
    update() {
      this.complete = this.number && this.expiry && this.cvc;

      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus();
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus();
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus();
        } else if (!this.number) {
          this.$refs.cardNumber.focus();
        }
      }
      // no focus magic for the CVC field as it gets complete with three
      // numbers, but can also have four
    }
  }
};
</script>

<style>
.credit-card-inputs.complete {
  border: 2px solid green;
}
</style>
